export default "__VITE_ASSET__CART37HN__"